import { PushNotificationControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

interface Params {
  pushNotificationId: string;
  xTENANTID?: string;
}

/**
 * @author [Rajkumar Rathod]
 */
export const useReadNotification = () =>
  useMutationWithLoading(async (params: Params) => {
    return new PushNotificationControllerApi(
      getConfigObject()
    ).maskAsReadNotification(params?.pushNotificationId, params?.xTENANTID);
  });
